import * as appActionTypes from "ActionTypes/appActionTypes";
import appInitialState from "InitialStates/appInitialState";

const reducers = {
  setHideLibrary: (state, action) => {
    return {
      ...state,
      hideLibrary: action.hideLibrary
    };
  },
  setIsNfrMarket: (state, action) => {
    return {
      ...state,
      isNfrMarket: action.isNfrMarket
    };
  },
  setFirstName: (state, action) => {
    return {
      ...state,
      firstName: action.firstName
    };
  },
  setSelectedCountry: (state, action) => {
    return {
      ...state,
      selectedCountry: action.selectedCountry
    };
  },
  setIsArMarket: (state, action) => {
    return {
      ...state,
      isArMarket: action.isArMarket
    };
  },
  isVaultMarket: (state, action) => {
    return {
      ...state,
      isVaultMarket: action.isVaultMarket
    };
  },
  setLoginAgainStatus: (state, action) => {
    return {
      ...state,
      loginAgainStatus: action.loginAgainStatus
    };
  },
  setIsLoading: (state, action) => {
    return {
      ...state,
      isLoading: action.isLoading
    };
  },
  setCatalogType: (state, action) => {
    return {
      ...state,
      catalogType: action.catalogType
    };
  },
  setCatalogName: (state, action) => {
    return {
      ...state,
      catalogName: action.catalogName
    };
  },
  setCustomerType : (state, action) => {
    return {
      ...state,
      customerType : action.customerType
    }
  },
  setLastCompletedStep : (state, action) => {
    return {
      ...state,
      lastCompletedStep : action.lastCompletedStep
    }
  }
};

const appReducer = (state = appInitialState, action) => {
  switch (action.type) {
    case appActionTypes.SET_HIDE_LIBRARY:
      return reducers.setHideLibrary(state);
    case appActionTypes.SET_IS_NFR_MARKET:
      return reducers.setIsNfrMarket(state);
    case appActionTypes.SET_FIRST_NAME:
      return reducers.setFirstName(state);
    case appActionTypes.SET_SELECTED_COUNTRY:
      return reducers.setSelectedCountry(state);
    case appActionTypes.SET_IS_AR_MARKET:
      return reducers.setIsArMarket(state);
    case appActionTypes.SET_IS_VAULT_MARKET:
      return reducers.isVaultMarket(state);
    case appActionTypes.SET_LOGIN_AGAIN:
      return reducers.setLoginAgainStatus(state, action);
    case appActionTypes.SET_IS_LOADING:
      return reducers.setIsLoading(state, action);
    case appActionTypes.SET_CATALOG_TYPE:
      return reducers.setCatalogType(state, action);
    case appActionTypes.SET_CATALOG_NAME:
      return reducers.setCatalogName(state, action);
    case appActionTypes.SET_CUSTOMER_TYPE:
      return reducers.setCustomerType(state, action);
    case appActionTypes.SET_LAST_COMPLETED_STEP:
        return reducers.setLastCompletedStep(state, action);
    default:
      return state;
  }
};

export default appReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/appReducer.js